export const menuItems = [
  {
    title: "Get Started",
    submenu: [
      {
        title: "Create",
        name: "Create",
      },
      {
        title: "Governance",
        name: "Governance",
      },
    ],
  },
  {
    title: "Discover",
    name: "Discover",
  },
  {
    title: "About Us",
    name: "AboutUs",
  },
  {
    title: "Docs",
    name: "Docs",
  },
];
